import React from 'react';
import { useTranslation } from "react-i18next";

export default function Footer()
{
    const { t } = useTranslation();
    return(
        <div>
        <footer className="footer text-center">
            <div className="container">
                <div className="row">
                    <div className="col-lg-4 mb-5 mb-lg-0">
                        <h4 className="text-uppercase mb-4">{t('footer_text1')}</h4>
                        <p className="lead mb-0">
                            <strong>Alajuela</strong>
                            <br />
                            <strong>Costa Rica</strong>
                        </p>
                    </div>
                    <div className="col-lg-4 mb-5 mb-lg-0">
                    </div>
                    <div className="col-lg-4">
                    <h4 className="text-uppercase mb-4">{t('footer_text2')}</h4>
                        <a className="btn btn-outline-light btn-social mx-1" target='_blank' rel="noopener noreferrer" href="https://www.facebook.com/profile.php?id=100067894733207"><i className="fab fa-fw fa-facebook-f"></i></a>
                        <a href="#!"><i></i></a>
                        <a className="btn btn-outline-light btn-social mx-1" target='_blank' rel="noopener noreferrer" href="https://www.linkedin.com/in/fabianquiros/"><i className="fab fa-fw fa-linkedin-in"></i></a>
                    </div>
                </div>
            </div>
        </footer>
        <div className="copyright py-4 text-center text-white">
            <div className="container"><small>Copyright &copy; Toolsoft 2025</small></div>
        </div>
        </div>
    )
}